import {initBoostrapSlider} from "@/helpers/bootstrap-slider-helper";
import {getActiveLayers, getBookmarkPresentations, getBookmarkPresentationsByID} from "@/helpers/ol/ol-layer-helper";
import {updateLanguage} from "@/modules/language/language";
import {initLayerStylePicker} from "@/helpers/layer-style-picker-helper";
import {initHideButton} from "@/helpers/layer/info/layer-info-helper";
import {initCollapse} from "@/helpers/collapse-helper";
import {toggleAccordionCollapse} from "@/helpers/bootstrap-accordion-helper";
import {getTemporaryLayers} from "@/helpers/layer/temporary/temporary-layer-helper";
import {
    getBySelector, hideElementsByDataAttribute,
    hideElementsBySelector,
    showElementsByDataAttribute,
    showElementsBySelector
} from "@/helpers/element-helper";
import {getBranchItemByBookmarkPresentationID} from "@/helpers/tree-helper";
import {getFileByService} from "@/helpers/file-helper";
import {getViewResolutionScale} from "@/helpers/ol/view/ol-view-resolutation-helper.js";

export function updateInfoLegends() {

    const bookmarkPresentations = getBookmarkPresentations(true)

    let innerHtml = ``

    innerHtml += `
    
    <div class="card m-3 bg-lighter" style="border-radius: 10px;min-height:460px" id="collapseLegend">
       <div class="card-header font-weight-bold p-2 info-menu-info-draggable">
          <h2>
              <span class="fa fa-list-ul"></span>
              <layout-language data-key="legend"></layout-language>
              <button title="Sluiten" class="btn icon-btn btn-sm btn-outline-secondary float-right btnHideInfoMenu">
                <span class="fa fa-times"></span>
              </button>
          </h2> 
       </div>
       <div class="info-card-body">
            <div class="card-body m-2 p-0">
                <layer-info-legend-search></layer-info-legend-search>
            </div>`

    let lastKey = 0
    let hasLegend = false

    bookmarkPresentations.sort((a, b) => {
        // Only sort on age if not identical
        if (a.SortingGroupDepth < b.SortingGroupDepth) return -1;
        if (a.SortingGroupDepth > b.SortingGroupDepth) return 1;

        if (a.SortingDepth < b.SortingDepth) return -1;
        if (a.SortingDepth > b.SortingDepth) return 1;
        // Sort on name
        // Both idential, return 0
        return 0;
    });


    bookmarkPresentations.map( (bookmarkPresentation, key) => {
        if(bookmarkPresentation.Visible && bookmarkPresentation.Legend !== '') {
            hasLegend = true
            innerHtml += generateInfoLegend(key, bookmarkPresentation.DisplayName, getLegendUrlByBookmarkPresentation(`#collapseLegend${key} img`, bookmarkPresentation))
            lastKey = key
        }
     })

    getTemporaryLayers().map((temporaryLayer, key) => {
        if(temporaryLayer.Styles) {
            hasLegend = true

            let url

            let styles
            try {
                styles = temporaryLayer.getSource().getParams().STYLES
            } catch (error) {
                return
            }

            if(styles) {
                temporaryLayer.Styles.map(style => {
                    if (style.Name === styles) {
                        url = style.LegendURL[0]
                    }
                })
            } else {
                url = temporaryLayer.Styles[0].LegendURL[0]
            }

            // WMS
            if(url.OnlineResource) {
                url = url.OnlineResource
            } else if(url.href) {
                // WMTS
                url = url.href
            }

            innerHtml += generateInfoLegend(lastKey + key + 1, temporaryLayer.Name, url)
        }
    })

innerHtml += `</div>
    </div>
    `;

    document.querySelector('layer-info-legend').innerHTML = innerHtml

    initHideButton()
    // initCollapse()
    updateLanguage()

    const element = document.querySelector('.btnLegendCollapseHide')
    if(element) {
        element.addEventListener('click', () => {
            toggleAccordionCollapse('layer-info-legend')
        })
        document.querySelector('.btnLegendCollapseShow').addEventListener('click', () => {
            toggleAccordionCollapse('layer-info-legend', false)
        })
    }

    if(hasLegend) {
        showElementsBySelector('layer-info-legend-button')
        showElementsByDataAttribute('data-id', '4', 'data-step', '6');
    } else {
        hideElementsBySelector('layer-info-legend-button')
        hideElementsByDataAttribute('data-id', '4', 'data-step', '6');
    }

    generatePrintLegends()
}

export function generateInfoLegend(key, displayName, url) {
    return `
        <div class="card ml-2 mt-2 mr-2 mb-1 layer-info-legend-item" data-label="` + displayName + `">
            <div class="card-header p-2">
              <a href="#" class="font-weight-bold text-dark accordion-header d-block" data-bs-target="#collapseLegend` + key + `" data-bs-toggle="collapse" aria-expanded="true">
                ` + displayName + `
                <div class="collapse-icon float-right"></div>
              </a>
            </div>
            <div id="collapseLegend` + key + `" class="collapse show pb-2 pt-2" data-parent="#collapseLegend" style="">
              <div class="card-body pl-2 pr-2">
                <img class="img-legend" src="` + url + `">
              </div>
            </div>
        </div>`
}

export function generatePrintLegends() {
    const divPrintLegends = getBySelector('#divPrintLegends');
    const divPrintSelectLayer = getBySelector('#divPrintSelectLayer');

    if(divPrintLegends) {
        divPrintLegends.innerHTML = ''
        getBookmarkPresentations(true).map( (bookmarkPresentation, key) => {
            if (bookmarkPresentation.Visible && bookmarkPresentation.Legend !== '') {

                let value = window.kaartViewerUrl +  `/admin/v2/kaartviewerapi/bookmark/${window.websiteID}/domain/${bookmarkPresentation.DomainID}/presentation/${bookmarkPresentation.PresentationID}/legend`

                value += '?scale=' + getViewResolutionScale()
                if(bookmarkPresentation.StyleActive) {
                    value += '&style=' + bookmarkPresentation.StyleActive
                }

                let checked = ''
                if(window.printLegends && window.printLegends.includes(bookmarkPresentation.BookmarkPresentationID)) {
                    checked = 'checked'
                }

                divPrintLegends.innerHTML += `
                    <div class="form-group">
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" ${checked} data-bookmark-presentation-id="${bookmarkPresentation.BookmarkPresentationID}" data-display-name="${bookmarkPresentation.DisplayName}" class="custom-control-input chbSelLegend" value="${value}">
                            <span class="custom-control-label">${bookmarkPresentation.DisplayName}</span>
                         </label>
                    </div>
        `
            }
        })
        if(divPrintLegends.innerHTML === '') {
            divPrintLegends.closest('.form-group').classList.add('d-none');
        } else {
            divPrintLegends.closest('.form-group').classList.remove('d-none');
        }

        const slcPrintSelectLayer = getBySelector('#slcPrintSelectLayer');
        let innerHTML = `<option value="">Kies mijn laag</option>`;

        getActiveLayers().map(layer => {
            if (layer && layer.Type === 'WMS') {
                innerHTML += `<option value="${layer.ID}">${layer.DisplayName}</option>`
            }
        });

        if (innerHTML === '<option value="">Kies mijn laag</option>') {
            divPrintSelectLayer.firstElementChild.classList.add('d-none');
        } else {
            divPrintSelectLayer.firstElementChild.classList.remove('d-none');
        }

        slcPrintSelectLayer.innerHTML = innerHTML;
    }
}

export function getLegendUrlByBookmarkPresentation(element, bookmarkPresentation) {

    let legend = bookmarkPresentation.Legend

    let extraUrlParams = '?scale=' + getViewResolutionScale()
    if(legend.includes('?')) {
        extraUrlParams = '&scale=' + getViewResolutionScale()
    }

    if(bookmarkPresentation.Service && bookmarkPresentation.Service.Proxy) {

        extraUrlParams = '?scale=' + getViewResolutionScale()

        if(bookmarkPresentation.StyleActive) {
            extraUrlParams += '&style=' + bookmarkPresentation.StyleActive
        }

        const url = window.kaartViewerUrl +  `/admin/v2/kaartviewerapi/bookmark/${window.websiteID}/domain/${bookmarkPresentation.DomainID}/presentation/${bookmarkPresentation.PresentationID}/legend`
        getFileByService(url + extraUrlParams).then(blob => {
            const selector = getBySelector(element)
            if(selector) {
                selector.src = URL.createObjectURL(blob)

                if(window.activeCharacteristicsBookmarkID && parseInt(window.activeCharacteristicsBookmarkID) === bookmarkPresentation.ID) {
                    const img = getBySelector('layer-info-characteristics img')
                    if(img) {
                        img.src = selector.src
                    }
                }
            }
        })
        return ''
    }

    if(bookmarkPresentation.StyleActive) {

        if(legend.includes('?')) {
            legend += '&'
        } else {
            legend += '?'
        }

        extraUrlParams = 'style=' + bookmarkPresentation.StyleActive
    }

    const selector = getBySelector(element)
    if(selector) {
        selector.src = legend + extraUrlParams
    }

    return legend + extraUrlParams
}